import React, { useEffect, useRef } from 'react';
import Button from '../../../generic-components/Button';
import Heading from '../../../generic-components/Heading';
import { ACTION_TYPES, STYLES } from '../constants';

interface IAction {
  imgUrl: string;
  actionType: string;
  title?: string;
}

interface IProps {
  actions: IAction[];
  emitAction?: (type: string) => void;
  isActionActive: boolean;
}

export const CategorizeActions = ({ actions, emitAction, isActionActive }: IProps) => {
  const elImg = useRef<any>();
  const handleAction = (type: string) => {
    if (emitAction && !isActionActive) {
      emitAction(type);
    }
  };

  useEffect(() => {
    if (elImg.current) {
      elImg.current?.classList.remove('fadeIn');
      setTimeout(() => {
        elImg.current?.classList.add('fadeIn');
      }, 100);
    }
  }, [actions]);

  return (
    <div ref={elImg} className='w-full flex items-center justify-center gap-[10px]'>
      {actions.map((action: IAction) => (
        <div key={action.actionType} className='flex flex-col'>
          <Button
            onClick={() => handleAction(action.actionType)}
            childElement={
              <img className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]' src={action.imgUrl} alt={action.actionType} />
          }
            className={action.actionType === ACTION_TYPES.SPLIT ? STYLES.MAIN_SECTION.ACTION_SPLIT_BTN : STYLES.MAIN_SECTION.ACTION_BUTTONS}
            id={action.actionType}
          />
          {action.title && <Heading title={action.title} className='text-center font-metric text-[14px] text-bw08' />}
        </div>
      ))}
    </div>
  );
};
